import React, {useState} from 'react';
import {findNumberedQuestion, validQuestionNumber} from './voiceCommands';

export default function QuestionNumberSearch({questions, onOpen, disabled=false}) {
    const [typed, setTyped] = useState('');
    const [message, setMessage] = useState('');
    const open = event => {
        event.preventDefault();
        if (disabled) return;
        const number = validQuestionNumber(typed);
        if (number === null) { setMessage('Enter a question number between 1 and 9999, such as 12.'); return; }
        const match = findNumberedQuestion(questions, number);
        if (match.error) { setMessage(match.error); return; }
        const opened = onOpen(match.question);
        setMessage(opened === false ? 'Stayed on this question.' : `Opened question ${number}.`);
    };
    return <section className="iq-number-search" aria-label="Find a question by number">
        <form onSubmit={open}>
            <label>Question number<input aria-label="Question number to open" placeholder="e.g. 12" inputMode="numeric" maxLength={4} value={typed} onChange={event=>{setTyped(event.target.value);setMessage('');}} disabled={disabled}/></label>
            <button className="iq-secondary" disabled={disabled || !typed.trim()} type="submit">Open question →</button>
        </form>
        {message && <p role="status">{message}</p>}
    </section>;
}
